import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.quotationLogsTab.title, 'Logs'),
  logDate: () => __(translations.quotationLogsTab.logDate, 'Date'),
  user: () => __(translations.quotationLogsTab.user, 'User'),
  action: () => __(translations.quotationLogsTab.action, 'Action'),
};
